import {
  createMultiStyleConfigHelpers,
  StyleThemingProps,
} from '@chakra-ui/react'
import { asChakraVariable, themeColorSectionKeys } from '~/themes/colors/colors'
import { textStyleKeys } from '~/themes/textStyles'
import { useCustomMultiStyleConfig } from '~/utils/chakraUtils'
import { getName } from '~/utils/objectUtils'

import { sharedComponentColorKeys } from './_colors'

export enum TextButtonVariants {
  Gray_900 = 'Gray_900',
  Gray_1300 = 'Gray_1300',
  Gray_1600 = 'Gray_1600',
}

const Colors = sharedComponentColorKeys.TextButton

const {
  Button: {
    FocusVisible: { BoxShadow: BoxShadowColor },
  },
} = themeColorSectionKeys.defaults

const TextButtonParts = ['container', 'icon', 'text'] as const

const helpers = createMultiStyleConfigHelpers(TextButtonParts)
export const TextButtonStyle = helpers.defineMultiStyleConfig({
  baseStyle: (props) => ({
    container: {
      display: 'inline-flex',
      justifyContent: 'center',
      alignItems: 'center',
      gap: '0.5rem',
      px: '0.25rem',
      py: 0,
      background: 'transparent',
      height: 'auto',
      marginLeft: '-0.25rem',
      cursor: 'pointer',
      _hover: {
        backgroundColor: 'transparent',
      },
      _active: {
        backgroundColor: 'transparent',
      },
      _focusVisible: {
        outline: 'none',
        borderRadius: '3px',
        boxShadow: `${asChakraVariable(BoxShadowColor)} 0px 0px 0px 2px`,
      },
    },
    icon: {
      boxSize: props.iconSize ?? '1rem',
      color: Colors.Text.FontColor,
      _groupHover: {
        color: Colors.Text.Hover.FontColor,
      },
      _groupActive: {
        color: Colors.Text.Active.FontColor,
      },
    },
    text: {
      textStyle: textStyleKeys.Body2_Bold,
      lineHeight: '1.25rem',
      color: Colors.Text.FontColor,
      _groupHover: {
        color: Colors.Text.Hover.FontColor,
      },
      _groupActive: {
        color: Colors.Text.Active.FontColor,
      },
    },
  }),
  variants: {
    [TextButtonVariants.Gray_900]: {
      text: {
        color: `${asChakraVariable('gray.900')}`,
      },
      icon: {
        color: `${asChakraVariable('gray.900')}`,
      },
    },
    [TextButtonVariants.Gray_1300]: {
      text: {
        color: `${asChakraVariable('gray.1300')}`,
      },
      icon: {
        color: `${asChakraVariable('gray.1300')}`,
      },
    },
    [TextButtonVariants.Gray_1600]: {
      text: {
        color: `${asChakraVariable('gray.1600')}`,
      },
      icon: {
        color: `${asChakraVariable('gray.1600')}`,
      },
    },
  },
})

export const useTextButtonStyle = (
  props?: StyleThemingProps & { iconSize?: string },
) => {
  return useCustomMultiStyleConfig<typeof TextButtonParts>(
    getName({ TextButtonStyle }),
    props,
  )
}
